import { Component } from 'react';
import { getAllItems } from '../../services/JsonFetchService.js';
import './FileList.css';

class FileList extends Component {
    constructor() {
        super();
        this.state = { infoItems: [] };
    }

    async componentDidMount() {
        const infoItems = await getAllItems(this.props.path);
        if (infoItems.length > 0) {
            this.setState({ infoItems: infoItems })
        }
    }

    render() {
        let list = this.state.infoItems.map((item, index) => {
            return <li key={index}>
                <a className="file-list__item-title" href={item.fileName} target="_blank" rel="noreferrer">{item.title}</a>
                <a className="file-list__item-download-icon" href={item.fileName} download>
                    <span className="file-list__icon-wrapper">
                        <i className="bi-download text-light file-list__icon"></i>
                    </span>
                </a>
            </li>
        })
        return (
            <div>
                <h2 className='file-list__title'>{this.props.title}</h2>
                <ul className="file-list__list">
                    {list}
                </ul>
            </div>
        )
    }
}

export default FileList;